import { makeStyles } from '@material-ui/core/styles';
import { rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(() => ({
  lineItem: {
    fontSize: rem(1.12),
    fontWeight: 500,
    minHeight: '33px',
    lineHeight: '35px',

    color: themeColor.subheaderLight,
  },
  lineItemBlackText: {
    fontSize: rem(1.12),
    fontWeight: 500,
    minHeight: '33px',
    lineHeight: '35px',
    color: themeColor.modalTitle,
  },
  price: {
    textAlign: 'right',
    fontSize: vh(1.7),
    fontWeight: 500,
  },
}));
